import React, {Fragment, useState} from 'react';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import {
  faArrowLeft,
  faBriefcase,
  faBuilding,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useDispatch, useSelector} from "react-redux";
import {SideMenuActions} from "../../Store/SideMenu/Slice";
import {Anchor, OPTION_LIST, SlideOptions} from "../../Store/SideMenu/Types";
import {RootState} from "../../Store/Reducers";
import {AuthActions} from "../../Store/Auth/Slice";
import SlideMenuTopInfoComponent from "../Shared/SlideMenuTopInfoComponent";
import {Customer} from "../../Models/Customer";
import {Company} from "../../Models/Company";
import {CompanyActions} from "../../Store/Company/Slice";
import {PickupActions} from "../../Store/Pickup/Slice";
import {useHistory} from "react-router-dom";

const anchors = ['left'] as Anchor[];

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});


const SlideMenuComponent = () => {

  const dispatch = useDispatch();
  const classes = useStyles();
  let history = useHistory();

  const {
    SideMenuReducer: {state, page: {first}},
    CompanyReducer: {companies, branch_selected, company_selected},
    authReducer: {logged}
  } = useSelector((state: RootState) => state);

  const toggleDrawer = (anchor: Anchor, open: boolean) => (
    event: React.KeyboardEvent | React.MouseEvent,
  ) => {
    if (
      event &&
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key !== 'Escape')
    ) {
      return;
    }
    dispatch(SideMenuActions.changeStatus({...state, [anchor]: open}));
    !Boolean(open) && first && console.log('initial state');
  };

  const handleAction = (name: string) => {
    if (name === SlideOptions.SALIR) {
      return dispatch(AuthActions.logout());
    }
    if (name === SlideOptions.INICIO) {
      dispatch(SideMenuActions.changeStatus({...state, [anchors[0]]: false}));
      return history.push('/dashboard');
    }
    if (name === SlideOptions.FACTURAS) {
      dispatch(SideMenuActions.changeStatus({...state, [anchors[0]]: false}));
      return history.push('/billing');
    }
    if (name === SlideOptions.HISTORIAL) {
      dispatch(SideMenuActions.changeStatus({...state, [anchors[0]]: false}));
      return history.push('/history');
    }
    if (name === 'main-page') {
      dispatch(SideMenuActions.changeToSecondPage(!first));
    }
    return
  };

  const [customer, setCustomer] = useState<Customer>();

  const handleSecondPage = (company: Company) => {

    const {customer} = company;
    if (customer?.branch_company.length) {
      setCustomer(customer);
      return dispatch(SideMenuActions.changeToSecondPage(!first));
    } else {
      dispatch(CompanyActions.setBranchSelected({}));
      dispatch(CompanyActions.setCompanySelected(customer));
      dispatch(SideMenuActions.changeToInitialState());
    }
    return dispatch(PickupActions.getPickups());
  };

  const setCustomerSelected = (branch: Customer) => {

    dispatch(CompanyActions.setBranchSelected(branch));
    dispatch(SideMenuActions.changeToInitialState());

    if ((company_selected as Customer)._KEY !== customer?._KEY) {
      dispatch(CompanyActions.setCompanySelected(customer));
    }
    dispatch(PickupActions.getPickups());
  };

  const list = (anchor: Anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onKeyDown={toggleDrawer(anchor, false)}
    >

      <SlideMenuTopInfoComponent/>

      {
        logged &&
        <>
          <List>
            {companies?.map((company: any, index: number) => {
              return (
                <Fragment key={company._KEY}>
                  <ListItem selected={company?.customer?._KEY === (company_selected as Customer)?._KEY}
                            onClick={() => handleSecondPage(company)} button>
                    <ListItemIcon>{index % 2 === 0 ? <FontAwesomeIcon icon={faBuilding}/> :
                      <FontAwesomeIcon icon={faBriefcase}/>}</ListItemIcon>

                    <ListItemText className="one-line-text" primary={company?.customer?.name}/>
                    {Boolean(company?.customer?.branch_company?.length) && <FontAwesomeIcon color="gray" icon={faChevronRight}/>}
                  </ListItem>
                </Fragment>
              );

            })}
          </List>
          <Divider/>
          <List>
            {OPTION_LIST.map((option, index) => (
              <ListItem onClick={() => handleAction(option.text)} button key={option.text}>
                <ListItemIcon>
                  <FontAwesomeIcon icon={option.icon}/>
                </ListItemIcon>
                <ListItemText primary={option.text}/>
              </ListItem>
            ))}
          </List>
        </>
      }

    </div>
  );

  const secondList = (anchor: Anchor) => (
    <div className={clsx(classes.list, {[classes.fullList]: anchor === 'top' || anchor === 'bottom',})}
         role="presentation"
         onKeyDown={toggleDrawer(anchor, false)}>

      <SlideMenuTopInfoComponent/>

      <ListItem onClick={() => handleAction('main-page')} button key={'back-to-main-page-123'}>
        <ListItemIcon> <FontAwesomeIcon icon={faArrowLeft}/> </ListItemIcon>
        <ListItemText primary={'Atrás'}/>
      </ListItem>

      {Boolean(customer?.branch_company.length) &&
      (customer?.branch_company as any)?.map((branch: any) => {
        return (
          <ListItem selected={branch?._KEY === (branch_selected as Customer)._KEY}
                    onClick={() => setCustomerSelected(branch)} button key={'branch-' + branch._KEY}>
            <ListItemIcon/>
            <ListItemText primary={branch?.name}/>
          </ListItem>);
      })}
    </div>
  );

  return (
    <div>
      {anchors.map((anchor) => (
        <React.Fragment key={anchor}>
          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
          >
            {!first && list(anchor)}
            {first && secondList(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
};

export default SlideMenuComponent;
